import React, { useCallback, useState } from 'react';

import { Col } from '@opendoor/atoms/box';
import { Image } from '@opendoor/atoms/image';
import { IconHome } from '@tabler/icons-react';

interface HubPropertyPhotoProps {
  photoUrl?: string | null;
  onError?: () => void;
}

/**
 * Property photo that fills its parent and falls back to a neutral placeholder
 * when there is no photo URL or the image fails to load.
 */
export const HubPropertyPhoto: React.FC<HubPropertyPhotoProps> = ({ photoUrl, onError }) => {
  const [didFailToLoad, setDidFailToLoad] = useState(false);
  const handleError = useCallback(() => {
    if (onError) {
      onError();
      return;
    }
    setDidFailToLoad(true);
  }, [onError]);

  if (!photoUrl || didFailToLoad) {
    return (
      <Col className="inset-0 h-full w-full items-center justify-center bg-od-bg-secondary text-od-content-tertiary">
        <IconHome size={24} />
      </Col>
    );
  }

  return (
    <Image
      alt=""
      src={photoUrl}
      onError={handleError}
      className="inset-0 w-full h-full object-cover"
    />
  );
};
